// ─── Mock data for demo/dev mode ────────────────────────
export const MOCK_USER = {
  id: '1',
  name: 'Admin PostFlow',
  email: 'admin@postflow.ai',
  role: 'admin',
  avatar: null,
};

export const MOCK_PROJECTS = [
  { id: '1', name: 'SaaS Dashboard Pro', description: 'Herramienta de análisis de datos para empresas', tone: 'profesional', keywords: 'SaaS, datos, analytics, empresas', hashtags: '#SaaS #Tech #Datos', color: '#7c3aed' },
  { id: '2', name: 'DevFlow App', description: 'Gestión de proyectos para desarrolladores', tone: 'casual', keywords: 'dev, code, productividad, git', hashtags: '#Dev #Code #Productividad', color: '#2563eb' },
  { id: '3', name: 'CloudSync', description: 'Sincronización de archivos en la nube', tone: 'inspiracional', keywords: 'cloud, sync, archivos, equipo', hashtags: '#Cloud #Sync #Team', color: '#10b981' },
];

export const MOCK_ACCOUNTS = [
  { id: '1', network: 'instagram', name: '@miempresa', type: 'business', connected: true, avatar: null, followers: 12400 },
  { id: '2', network: 'linkedin', name: 'Mi Empresa Tech', type: 'company', connected: true, avatar: null, followers: 3200 },
  { id: '3', network: 'twitter', name: '@miempresa_dev', type: 'personal', connected: true, avatar: null, followers: 8900 },
  { id: '4', network: 'tiktok', name: '@miempresa', type: 'personal', connected: false, avatar: null, followers: 0 },
  { id: '5', network: 'facebook', name: 'Mi Empresa Fan Page', type: 'page', connected: true, avatar: null, followers: 5600 },
  { id: '6', network: 'youtube', name: 'Mi Empresa Canal', type: 'channel', connected: true, avatar: null, followers: 920 },
];

export const MOCK_PROVIDERS = [
  { id: '1', name: 'DeepSeek', slug: 'deepseek', model: 'deepseek-chat', endpoint: 'https://api.deepseek.com/v1', active: true, supports_vision: false, cost_per_1k: 0.002 },
  { id: '2', name: 'OpenAI GPT-4o', slug: 'openai', model: 'gpt-4o', endpoint: 'https://api.openai.com/v1', active: false, supports_vision: true, cost_per_1k: 0.015 },
  { id: '3', name: 'Google Gemini', slug: 'gemini', model: 'gemini-1.5-pro', endpoint: 'https://generativelanguage.googleapis.com/v1', active: false, supports_vision: true, cost_per_1k: 0.007 },
  { id: '4', name: 'Grok', slug: 'grok', model: 'grok-2', endpoint: 'https://api.x.ai/v1', active: false, supports_vision: false, cost_per_1k: 0.01 },
  { id: '5', name: 'Claude', slug: 'claude', model: 'claude-sonnet-4-20250514', endpoint: 'https://api.anthropic.com/v1', active: false, supports_vision: true, cost_per_1k: 0.012 },
];

export const MOCK_POSTS = [
  {
    id: '1', project_id: '1', media_type: 'image', thumbnail: null,
    created_at: new Date(Date.now() - 86400000 * 2).toISOString(),
    status: 'published',
    networks: [
      { network: 'instagram', status: 'published', likes: 243, comments: 18, shares: 12, reach: 3400, impressions: 4200 },
      { network: 'linkedin', status: 'published', likes: 89, comments: 7, shares: 24, reach: 1200, impressions: 1800 },
      { network: 'twitter', status: 'published', likes: 156, comments: 9, shares: 43, reach: 5600, impressions: 8900 },
    ],
  },
  {
    id: '2', project_id: '2', media_type: 'video', thumbnail: null,
    created_at: new Date(Date.now() - 86400000 * 5).toISOString(),
    status: 'published',
    networks: [
      { network: 'instagram', status: 'published', likes: 512, comments: 34, shares: 28, reach: 8900, views: 14200, impressions: 18000 },
      { network: 'tiktok', status: 'published', likes: 2300, comments: 189, shares: 430, reach: 45000, views: 89000, impressions: 92000 },
    ],
  },
  {
    id: '3', project_id: '1', media_type: 'image', thumbnail: null,
    created_at: new Date(Date.now() - 3600000 * 6).toISOString(),
    status: 'partial',
    networks: [
      { network: 'instagram', status: 'published', likes: 67, comments: 4, shares: 3, reach: 890, impressions: 1100 },
      { network: 'facebook', status: 'failed', error: 'Token expirado' },
    ],
  },
];

export const MOCK_ANALYTICS = {
  totals: { posts: 47, reach: 284000, likes: 18400, comments: 1230, shares: 3400, video_views: 156000 },
  growth: { posts: 12, reach: 23, likes: 18, comments: 8 },
  by_network: [
    { network: 'instagram', posts: 18, reach: 89000, likes: 7200, engagement: 4.2 },
    { network: 'tiktok', posts: 12, reach: 112000, likes: 8900, engagement: 8.7 },
    { network: 'twitter', posts: 22, reach: 45000, likes: 1800, engagement: 2.1 },
    { network: 'linkedin', posts: 15, reach: 28000, likes: 420, engagement: 3.4 },
    { network: 'facebook', posts: 10, reach: 18000, likes: 680, engagement: 1.8 },
    { network: 'youtube', posts: 5, reach: 24000, likes: 340, engagement: 5.1 },
  ],
  chart: Array.from({ length: 30 }, (_, i) => ({
    date: new Date(Date.now() - (29 - i) * 86400000).toLocaleDateString('es', { month: 'short', day: 'numeric' }),
    reach: Math.floor(Math.random() * 12000 + 3000),
    likes: Math.floor(Math.random() * 800 + 100),
    posts: Math.floor(Math.random() * 4),
  })),
};

export const NETWORK_CONFIG = {
  instagram: { name: 'Instagram', icon: '📸', color: '#E1306C', supports: ['image', 'video', 'reel', 'story'] },
  tiktok: { name: 'TikTok', icon: '🎵', color: '#69C9D0', supports: ['video', 'story'] },
  twitter: { name: 'X / Twitter', icon: '✕', color: '#1DA1F2', supports: ['image', 'video'] },
  linkedin: { name: 'LinkedIn', icon: 'in', color: '#0A66C2', supports: ['image', 'video'] },
  facebook: { name: 'Facebook', icon: 'f', color: '#1877F2', supports: ['image', 'video'] },
  youtube: { name: 'YouTube', icon: '▶', color: '#FF0000', supports: ['video'] },
  google_calendar: { name: 'Google Calendar', icon: '📅', color: '#4285F4', supports: [] },
  gmail: { name: 'Gmail', icon: '📧', color: '#EA4335', supports: [] },
};

export const AI_GENERATED_CONTENT = {
  instagram: {
    caption: '🚀 Transforma la manera en que tu equipo trabaja.\n\nSimple. Rápido. Poderoso. Esto es exactamente lo que necesitabas y no sabías.\n\n¿Ya lo probaste? Cuéntanos en los comentarios 👇',
    hashtags: '#SaaS #Tech #Productividad #Software #Startup #Dev #Innovation',
  },
  tiktok: {
    caption: '¿Sigues haciendo esto manual? 👀 Mira la diferencia en solo 30 segundos 🔥 #software #dev #automatizacion #tech #startup #productividad',
    hashtags: '#software #dev #automatizacion',
  },
  twitter: {
    caption: 'Acabamos de lanzar algo que va a cambiar tu flujo de trabajo para siempre.\n\nNo exagero. Pruébalo gratis 👇',
    hashtags: '',
  },
  linkedin: {
    caption: 'Me complace compartir nuestra última actualización 🎯\n\nDurante los últimos meses hemos trabajado en resolver un problema que afecta a miles de equipos: la pérdida de tiempo en tareas repetitivas.\n\nEl resultado habla por sí solo. ¿Cuál es el mayor reto de productividad en tu empresa?',
    hashtags: '#Innovación #Software #Emprendimiento #Productividad',
  },
  facebook: {
    caption: '¡Gran noticia para nuestra comunidad! 🎉\n\nAcaba de llegar la nueva versión, más rápida e intuitiva que nunca. Entra y descúbrela, tienes 14 días gratis 👇',
    hashtags: '',
  },
  youtube: {
    caption: 'En este video te mostramos exactamente cómo funciona nuestra herramienta y por qué cientos de equipos ya la están usando para ser más productivos.',
    hashtags: '#Tutorial #Software #Productividad #SaaS',
  },
};
